import { render, staticRenderFns } from "./scenery-box-ming.vue?vue&type=template&id=97c21b7a&scoped=true&"
import script from "./scenery-box-ming.vue?vue&type=script&lang=js&"
export * from "./scenery-box-ming.vue?vue&type=script&lang=js&"
import style0 from "./scenery-box-ming.vue?vue&type=style&index=0&id=97c21b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c21b7a",
  null
  
)

export default component.exports